import { Outlet, useLocation } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { StudentSidebar } from "./StudentSidebar";
import { MobileBottomNav } from "./MobileBottomNav";
import { useAuth } from "@/contexts/AuthContext";
import { OnboardingProvider } from "@/contexts/OnboardingContext";
import { SkipLink } from "@/components/ui/skip-link";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { MaintenanceNotification } from "@/components/notifications/MaintenanceNotification";
import { FAQChatButton } from "@/components/faq/FAQChatButton";

const StudentLayout = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return null;
  }

  const isOnChatPage = location.pathname === '/student/chat';

  return (
    <OnboardingProvider>
      <SidebarProvider>
        <SkipLink href="#main-content" />
        <MaintenanceNotification />
        <div className="flex h-dvh w-full bg-background">
          {/* Desktop: Sidebar */}
          <div className="hidden md:block">
            <StudentSidebar />
          </div>

          {/* Mobile: Header with Notification Bell */}
          <header className="fixed top-0 left-0 right-0 h-10 bg-background border-b z-40 md:hidden flex items-center justify-end px-3">
            <NotificationBell />
          </header>

          <main
            id="main-content"
            className={`flex-1 bg-muted/30 overflow-x-hidden ${
              isOnChatPage
                ? 'flex flex-col min-h-0 overflow-hidden pt-10 md:pt-0'
                : 'p-6 pt-16 pb-20 md:pt-6 md:pb-6'
            }`}
            role="main"
            aria-label="メインコンテンツ"
            tabIndex={-1}
          >
            {isOnChatPage ? (
              <div className="flex flex-1 flex-col px-3 py-2 pb-20 md:px-6 md:py-6 md:pb-6 min-h-0 overflow-hidden">
                <Outlet />
              </div>
            ) : (
              <Outlet />
            )}
          </main>

          {/* Mobile: Bottom Navigation */}
          <MobileBottomNav />

          {/* FAQ Help Chatbot */}
          <FAQChatButton />
        </div>
      </SidebarProvider>
    </OnboardingProvider>
  );
};

export default StudentLayout;
